<div class="section-header" data-cy="wait-list-dialog-header">
  <div class="section-header-title" data-cy="wait-list-dialog-title">Appointment Wait List</div>
</div>
<div style="display: flex; flex-direction: column; flex: 1; height: 80%" data-cy="wait-list-dialog-container">
  <div style="display: flex; flex-direction: row; flex: 1;" data-cy="wait-list-dialog-filters">
    <div style="display: flex; flex-direction: row; width: 35%; padding-left: 15px" data-cy="wait-list-dialog-doctor-filter">
      <tdo-dropdown-v2 [isIncludeAll]="true"
        [isMultiSelect]="true"
        [isAutoSelectAll]="true"
        placeholder="Select Doctor"
        [value]="selectedDoctor"
        [datasource]="DoctorList"
        (selectionChange)="onDoctorSelectionChange($event)"
        (closed)="onDoctorSelectionChange($event)"
        displayProperty="Doctor_FullName"
        style="width: 100%;"
        data-cy="wait-list-dialog-doctor-dropdown">
      </tdo-dropdown-v2>
    </div>
    <div style="display: flex; flex-direction: row;" data-cy="wait-list-dialog-sort-options">
      <mat-radio-group aria-label="Report For" data-cy="wait-list-dialog-sort-group">
        <div style="display: flex; flex-direction: row; padding-left: 5px" data-cy="wait-list-dialog-sort-container">
          <div style="display: flex; flex-direction: column;" data-cy="wait-list-dialog-date-sort">
            <mat-radio-button [checked]="true"
              value="RD-ASC"
              (change)="onShowTasksChange($event)"
              color="primary" style="word-wrap: inherit"
              data-cy="wait-list-dialog-date-asc">
              Sort By RequestedDate ASC
            </mat-radio-button>
            <mat-radio-button [checked]="false"
              value="RD-DESC"
              (change)="onShowTasksChange($event)"
              color="primary" style="word-wrap: inherit"
              data-cy="wait-list-dialog-date-desc">
              Sort By RequestedDate DESC
            </mat-radio-button>
          </div>
          <div style="display: flex; flex-direction: column;" data-cy="wait-list-dialog-referrer-sort">
            <mat-radio-button [checked]="false"
              value="RF-ASC"
              (change)="onShowTasksChange($event)"
              color="primary" style="word-wrap: inherit"
              data-cy="wait-list-dialog-referrer-asc">
              Sort By Referrer ASC
            </mat-radio-button>
            <mat-radio-button [checked]="false"
              value="RF-DESC"
              (change)="onShowTasksChange($event)"
              color="primary" style="word-wrap: inherit"
              data-cy="wait-list-dialog-referrer-desc">
              Sort By Referrer DESC
            </mat-radio-button>
          </div>
        </div>
      </mat-radio-group>
    </div>
  </div>
  @if (isLoading) {
    <div style="width: 100%; height: 50%" data-cy="wait-list-dialog-loading"><app-tdo-progress-spinner data-cy="wait-list-dialog-spinner"></app-tdo-progress-spinner></div>
  }
  @if (!isLoading) {
    <div style="display: flex; flex-direction: column; height: 80%" data-cy="wait-list-dialog-content">
      <h6 style="background-color: var(--tdo-primary); color: white; width: 100%; padding-left: 20px" data-cy="wait-list-dialog-subtitle">Schedule
      Appointments</h6>
      <mat-button-toggle-group style="flex-direction: column; width: 100%; overflow-y: scroll" data-cy="wait-list-dialog-items">
        @for (ref of waitListFilter; track ref) {
          <mat-button-toggle [checked]="ref === selectedApp" class="vertical"
            [value]="ref" data-cy="wait-list-dialog-item">
            <div style="display: flex; flex-direction:row; width: 800px; line-height: 30px;" data-cy="wait-list-dialog-item-content">
              <div style="display: flex; flex-direction:column; width:150px" data-cy="wait-list-dialog-item-dates">
                <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-start-date">
                  <span class="span" data-cy="wait-list-dialog-item-start-date-text">{{ref.StartDate | date: 'mediumDate'}}</span>
                </div>
                <div style="display: flex; flex-direction:row; margin-top: auto" data-cy="wait-list-dialog-item-requested-date">
                  <span class="spanShort" data-cy="wait-list-dialog-item-requested-date-text">Requested: {{ref.DateWaitListed | date: 'shortDate'}}</span>
                </div>
              </div>
              <div style="display: flex; flex-direction:column; width:120px" data-cy="wait-list-dialog-item-times">
                <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-start-time">
                  <span class="span" data-cy="wait-list-dialog-item-start-time-text">{{ref.StartDate | date: 'shortTime'}}</span>
                </div>
                <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-end-time">
                  <span class="span" data-cy="wait-list-dialog-item-end-time-text">{{ref.EndDate | date: 'shortTime'}}</span>
                </div>
                <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-scheduled-label">
                  <span class="span" data-cy="wait-list-dialog-item-scheduled-text">Scheduled</span>
                </div>
                <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-contact-label">
                  <span class="span" data-cy="wait-list-dialog-item-contact-text">Contact:</span>
                </div>
              </div>
              <div style="display: flex; flex-direction:column; width: 200px" data-cy="wait-list-dialog-item-patient">
                <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-patient-name">
                  <span style="font-weight: bold" class="span" data-cy="wait-list-dialog-item-patient-name-text">{{ref.Patient_FullName}}</span>
                </div>
                <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-referred-by">
                  <span style="font-weight: bold" data-cy="wait-list-dialog-item-referred-by-label">Referred By: </span> <span
                class="span" data-cy="wait-list-dialog-item-referred-by-text">{{ref.RefDoctor_FullName}}</span>
              </div>
              <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-subject">
                <span class="span" data-cy="wait-list-dialog-item-subject-text">{{ref.subject}}</span>
              </div>
              <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-mobile">
                <span class="span" data-cy="wait-list-dialog-item-mobile-text">M: {{ref.Patient_Contact}}</span>
              </div>
            </div>
            <div style="display: flex; flex-direction:column; width:250px" data-cy="wait-list-dialog-item-details">
              <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-doctor">
                <span style="font-weight: bold" data-cy="wait-list-dialog-item-doctor-label">Doctor:</span>
                <span class="span" data-cy="wait-list-dialog-item-doctor-text">
                {{ref.Doctor_FullName}} </span>
              </div>
              <div style="display: flex; flex-direction:column; align-items: flex-start" data-cy="wait-list-dialog-item-comment">
                <span style="font-weight: bold" data-cy="wait-list-dialog-item-comment-label">Comment:</span>
                <textarea [disabled]="true" ngModel="{{ref.Description}}" [rows]="2"
                style="line-height: 1.3; border: unset; height: fit-content;  overflow-y: auto; width: 90%" data-cy="wait-list-dialog-item-comment-text"></textarea>
              </div>
            </div>
            <div style="display: flex; flex-direction:column; width:60px; margin-top: 20px" data-cy="wait-list-dialog-item-actions">
              <div style="display: flex; flex-direction:row" data-cy="wait-list-dialog-item-view-action">
                <img (click)="ViewAppointment(ref)" src="../../../assets/icons/icons8_calendar_plus.svg"
                  matTooltip="Open Appointment" style="width: 35px" data-cy="wait-list-dialog-item-view-button">
                </div>
                <div style="display: flex; flex-direction:row; margin-top: 20px" data-cy="wait-list-dialog-item-reschedule-action">
                  <img (click)="PasteReschedule(ref)" style="object-fit: contain"
                    src="assets/Images/Calendar/iconDoctorNew.svg"
                    matTooltip="Paste Reschedule" data-cy="wait-list-dialog-item-reschedule-button"/>
                  </div>
                </div>
              </div>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    }
    <!--      BUTTONS-->
    <div style="flex-basis: 40px; text-align: right;margin:auto; margin-top:15px;" data-cy="wait-list-dialog-footer">
      <button mat-button class="tdo-button tdo-save" (click)="onOk()" data-cy="wait-list-dialog-ok-button">Ok</button>
    </div>
  </div>
